import {Client} from '../Axios'
import {ENDPOINT} from "../Axios/Api"
import IRecyclingStationsService from './IRecyclingStationsService'
import {AxiosResponse} from 'axios'
import {clearServerMessage, renderServerMessage} from "@apps/Shared/Utils/ServerMessage";
import i18n from "@apps/Shared/translation/i18n";

class RecyclingStationsService implements IRecyclingStationsService {
    async GetRecyclingStations(filter?: boolean) {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.RecyclingStations.Stations(filter)}`);
            clearServerMessage();

        } catch (error: any) {
            
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetStationDetails(stationId: string) {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.RecyclingStations.StationDetails(stationId)}`);
            clearServerMessage();
            
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }
}

export default new RecyclingStationsService();
